module.exports = __webpack_public_path__ + "img/free.245b6aa9.svg";